import {Atom, useAtomValue} from 'jotai';
import {AtomWithQueryResult} from 'jotai-tanstack-query';
import React from 'react';
import {useSelector} from 'react-redux';
import {Route, Routes} from 'react-router';
import {FallbackPage, LoadingScreen, NotFoundPage} from '~/entities/fallbacks';
import {selectCardsDisabledFlag} from '~/redux/cards/selectCardsList';
import {CardVerificationPage} from '../ui/verification/CardVerificationPage';
import {AddNewCardPage} from './add/AddNewCard';
import {CardsPage} from './list/CardsContainer/CardsPage';

interface Props {
    isPaymentRestrictedAtom: Atom<AtomWithQueryResult<boolean>>;
    phoneAtom: Atom<AtomWithQueryResult<string>>;
    emailAtom: Atom<AtomWithQueryResult<string>>;
}

export const CardRoutes = ({isPaymentRestrictedAtom, phoneAtom, emailAtom}: Props) => {
    const {data: isPaymentRestricted} = useAtomValue(isPaymentRestrictedAtom);
    const {data: phone, isSuccess: isPhoneSuccess} = useAtomValue(phoneAtom);
    const {data: email, isSuccess: isEmailSuccess} = useAtomValue(emailAtom);
    const isCardsDisabled = useSelector(selectCardsDisabledFlag) || Boolean(isPaymentRestricted);

    if (!phone || !email) {
        return <LoadingScreen />;
    }

    if (!isPhoneSuccess || !isEmailSuccess) {
        return <FallbackPage />;
    }

    return (
        <Routes>
            <Route
                index
                element={
                    <CardsPage isCardsDisabled={isCardsDisabled} isPaymentRestricted={Boolean(isPaymentRestricted)} />
                }
            />
            <Route path='add' element={<AddNewCardPage phone={phone} email={email} />} />
            <Route path=':id/verify' element={<CardVerificationPage />} />
            <Route path='*' element={<NotFoundPage />} />
        </Routes>
    );
};
